// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:37:45

export default {
  "id": "christmas-find-the-differences",
  "slug": "christmas-find-the-differences",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/6685976ee2f940178b2373cc5c23c75a-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/6685976ee2f940178b2373cc5c23c75a/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Christmas Find The Differences",
      "description": "Get into the festive spirit with Christmas Find The Differences, the ultimate holiday-themed puzzle game! Test your observation skills as you compare two seemingly identical pictures filled with Christmas cheer. Spot all the differences in magical settings featuring Christmas trees, snowy landscapes, stockings, and Santa himself!",
      "instructions": "Mouse Click",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "christmas",
        "differences",
        "find",
        "hidden",
        "santa"
      ]
    },
    "zh-CN": {
      "title": "圣诞找不同",
      "description": "沉浸在这份节日氛围中，体验《圣诞找不同》终极假日主题益智游戏！测试你的观察力，比较两张看似相同的充满圣诞欢乐的图片。在拥有圣诞树、雪地风光、袜子和圣诞老人等魔幻场景中找出所有不同之处！",
      "instructions": "鼠标点击",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "圣诞节",
        "差异",
        "寻找",
        "隐藏",
        "圣诞老人"
      ]
    },
    "zh-TW": {
      "title": "聖誕尋找不同處",
      "description": "進入節慶氣氛，享受《聖誕找不同》這款最終節日主題拼圖遊戲！挑戰你的觀察力，比較兩張看似相同的充滿聖誕歡樂的圖片。在充滿神奇設定的地方，如裝飾著基督聖樹、雪景、紅襪子和聖誕老人，尋找所有不同之處！",
      "instructions": "滑鼠點擊",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "聖誕節",
        "差異",
        "尋找",
        "隱藏",
        "聖誕老人"
      ]
    },
    "zh-HK": {
      "title": "聖誕尋找差異",
      "description": "投入聖誕節的氣氛，玩《聖誕尋找不同》這款終極節日主題的謎題遊戲！考验你的觀察力，比較兩幅看似相同的充滿聖誕氣息的圖片。在充滿奇蹟的聖誕樹、雪景、襪子和聖誕老人等設定中，找出所有不同之處！",
      "instructions": "滑鼠點擊",
      "genres": [
        "休闲",
        "謎題"
      ],
      "tags": [
        "聖誕節",
        "差異",
        "尋找",
        "隱藏",
        "聖誕老人"
      ]
    },
    "ja": {
      "title": "クリスマスの違いを見つけよう",
      "description": "クリスマスの雰囲気に浸ろう、究極の休日テーマのパズルゲーム「クリスマス・ファインド・ザ・ディファレンス」で観察力を試してみよう！見た目は全く同じに見える二つのクリスマスの喜びに満ちた写真を比較しながら、クリスマスツリー、雪景色、クリスマス紐、そしてサンタ自体が登場する魔法のセットで違いを見つけよう！",
      "instructions": "マウスクリック",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "クリスマス",
        "違い",
        "見つける",
        "隠された",
        "サンタ"
      ]
    },
    "ko": {
      "title": "크리스마스 차이점 찾기",
      "description": "Xmas Find The Differences, 최상급의 휴가 주제 펼창 파ズل 게임으로 명절 분위기를 만끽하세요! 두 개의 비교적 동일한 picture를 통해 겨울 복지를 찾아보며 관찰력을 테스트하세요. 나무, 눈이 쌓인 풍경, 장롱, 그리고 산타 자신을 포함한 마법적인 설정에서 모든 차이를 발견하세요!",
      "instructions": "마우스 클릭",
      "genres": [
        "캐주얼",
        "파ズл"
      ],
      "tags": [
        "크리스마스",
        "차이점",
        "찾아보기",
        "숨겨져있는",
        "산타"
      ]
    },
    "fr": {
      "title": "Trouver les Différences de Noël",
      "description": "Soyez dans l'esprit des fêtes avec Christmas Find The Differences, le jeu de puzzle de vacance ultime ! Testez votre acuité d'observation en comparant deux images apparemment identiques remplies de joie de Noël. Repérez toutes les différences dans des décors magiques mettant en scène des arbres de Noël, des paysages enneigés, des gants de Noël et même le Père Noël lui-même !",
      "instructions": "Clic souris",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "Noël",
        "différences",
        "trouver",
        "cachés",
        "Père Noël"
      ]
    }
  }
};
